import React, { useEffect, useState, useRef } from "react";
import sizes from "sizes";
import { splitMessage } from "./helpers";

export default ({ items, setEdit, pieces, colors, size="instagram" }) => {
  return <div className="Graphics">
    {items.map(({ id, message, defaultImage, defaultColorCombo, fontFamily }) => {
      const type = defaultImage[0].typeHandle;
      const imageId = defaultImage[0].id

      const piece = pieces.find(d => d.id === imageId)

      return (
        <button key={id}
          className="Graphic Graphic--image"
          onClick={() => {
            setEdit({
              type,
              fontFamily,
              message: {
                typeHandle: "text",
                text: message
              },
              image: imageId,
              defaultColorCombo: defaultColorCombo[0].id
            })
          }}>
          <Canvas
            piece={piece}
            type={type}
            message={{
              typeHandle: "text",
              text: message
            }}
            color={colors[defaultColorCombo[0].id]}
            size={size}
            fontFamily={fontFamily} />
        </button>
      )
    })}
  </div>
}

export const getSrc = (piece,type,size) => {
  switch (type) {
    case "tapestry":
      const orientation = sizes[size][type].variant
      return piece.imageVariants[0][orientation][0].url
    case "icon":
      return piece.image[0].url;
    default:
      throw new Error(`unknown piece type: ${type}`)
  }
}

const fontWeight = 700



export const Canvas = ({
  type,
  message,
  imageSrc,
  color,
  editDispatch,
  size,
  piece,
  fontFamily
}) => {
  const ref = useRef()
  const [image,setImage] = useState()

  useEffect(() => {
    const imageSrc = getSrc(piece,type,size);

    const newImage = new Image()
    const onLoad = () => {
      setImage(newImage)
    }
    newImage.addEventListener("load",onLoad);
    newImage.src = imageSrc

    return () => {
      newImage.removeEventListener("load",onLoad);
    }
  },[piece,type,size])

  useEffect(() => {
    if (ref.current && image) {
      const draw = async () => {
        const logo = await getLogo(color.text)

        const metrics = sizes[size]
        const [width,height] = metrics.size;
        const [imageX,imageY] = metrics[type].illustration.pos
        const [imageW,imageH] = metrics[type].illustration.size
        const [textX,textY] = metrics[type].text.pos
        const [textW,textH] = metrics[type].text.size
        const [logoX,logoY] = metrics[type].logo.pos
        const [logoW,logoH] = metrics[type].logo.size

        const padding = width*.04

        const messageType = message && message.typeHandle;


        const ctx = setupCanvas(ref.current,width,height)
        ctx.fillStyle = color.bg
        ctx.rect(0,0,width,height)
        ctx.fill()
        ctx.drawImage(image,imageX,imageY,imageW,imageH)

        switch (messageType) {
          case "image":
            const image = message.image[0]
            const pad = 40;
            const messageImage = await getImage(image.url);
            ctx.drawImage(
              messageImage,
              (textX + pad),
              (textY + pad),
              (textW - pad*2),
              ((textW-pad*2) * image.height/image.width)
            )
            break;

          case "text":
            const messageSplit = splitMessage(message.text)
            const messageIsPlaceholder = !!messageSplit

            const displayMessage = messageIsPlaceholder
              ? messageSplit[1] + (new Array(8).fill("_").join("")) + messageSplit[3]
              : message.text;

            let fontSize = maxFontSize(
              ctx,
              displayMessage,
              (textW - 2*padding),
              (textH - 2*padding),
              size => `${fontWeight} ${size}px ${fontFamily}`
            )

            do {
              fontSize--
              ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`
            } while (measureTextHeight(
              ctx,
              displayMessage,
              (textW - 2*padding),
              fontSize*1.2
            ) > (textH - 3*padding - logoH))

            ctx.fillStyle = color.text
            ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`
            wrapText(
              ctx,
              displayMessage,
              (textX + padding),
              (textY + (fontSize + padding)),
              (textW - 2*padding),
              fontSize*1.2
            )

            break;

          default:
            throw new Error(`unknown message type: ${message.typeHandle}`)
        }

        ctx.drawImage(logo,logoX + padding,logoY - padding,logoW,logoH)

        if (editDispatch && !module.hot) {
          editDispatch({
            type: "setDownload",
            value: ref.current.toDataURL('image/jpeg', 1.0)
          })
        }
      }
      draw()
    }
  },[ref,image,type,message,color,size,editDispatch,fontFamily])

  return <div className="Canvas">
    <canvas ref={ref} />
  </div>
}

const setupCanvas = (canvas,width,height) => {
  const dpr = window.devicePixelRatio || 1;
  canvas.width = width * dpr;
  canvas.height = height * dpr;

  const ctx = canvas.getContext('2d');
  ctx.scale(dpr, dpr);

  return ctx
}

const wrapText = (context, text, x, y, maxWidth, lineHeight) => {
  var words = text.split(' '),
    line = '',
    i,
    test,
    metrics;

  for (i = 0; i < words.length; i++) {
    test = words[i];
    metrics = context.measureText(test);
    while (metrics.width > maxWidth) {
      // Determine how much of the word will fit
      test = test.substring(0, test.length - 1);
      metrics = context.measureText(test);
    }
    if (words[i] !== test) {
      words.splice(i + 1, 0,  words[i].substr(test.length))
      words[i] = test;
    }

    test = line + words[i] + ' ';
    metrics = context.measureText(test);

    if (metrics.width > maxWidth && i > 0) {
      context.fillText(line, x, y);
      line = words[i] + ' ';
      y += lineHeight;
      // lineCount++;
    }
    else {
      line = test;
    }
  }

  context.fillText(line, x, y);
}

const measureTextHeight = (context, text, maxWidth, lineHeight) => {
  let y = 0
  var words = text.split(' '),
    line = '',
    i,
    test,
    metrics;

  for (i = 0; i < words.length; i++) {
    test = words[i];
    metrics = context.measureText(test);
    while (metrics.width > maxWidth) {
      // Determine how much of the word will fit
      test = test.substring(0, test.length - 1);
      metrics = context.measureText(test);
    }
    if (words[i] !== test) {
      words.splice(i + 1, 0,  words[i].substr(test.length))
      words[i] = test;
    }

    test = line + words[i] + ' ';
    metrics = context.measureText(test);

    if (metrics.width > maxWidth && i > 0) {
      line = words[i] + ' ';
      y += lineHeight;
      // lineCount++;
    }
    else {
      line = test;
    }
  }

  return y + lineHeight
}

const maxFontSize = (context, text, maxWidth, maxHeight, setFontSize) => {
  const longestWord = text.split(" ").sort((a,b) => b.length - a.length)[0]
  let size = maxHeight
  do {
    size--
    context.font = setFontSize(size)
  } while(context.measureText(longestWord).width > maxWidth)
  return size
}


const Logo = (fill="#000") => `<svg width="113" height="38" viewBox="0 0 113 38" fill="${fill}" xmlns="http://www.w3.org/2000/svg"><path d="M112.706 36.548H97.065V21.144h15.595v4.621H104v1.233h5.985v3.564h-5.984v1.255h8.705v4.73zm-33.05-5.721c1.156.814 3.038 1.386 4.489 1.364 1.065-.022 1.246-.264 1.246-.572 0-.308-.385-.44-1.677-.638-4.216-.638-6.03-2.377-6.03-4.753 0-2.685 2.539-5.546 8.342-5.546 2.698 0 6.12.88 7.708 2.025L90.946 26.6c-1.542-.902-2.744-1.188-3.968-1.165-.861 0-1.066.307-1.066.594 0 .286.273.418 1.633.616 4.194.638 6.076 2.354 6.076 4.775 0 2.927-2.517 5.567-8.615 5.567-3.196 0-6.279-.836-8.251-2.266l2.901-3.895zm-11.287-1.98c0-1.21-.816-2.025-2.018-2.025-1.2 0-2.017.814-2.017 2.024s.816 2.025 2.017 2.025c1.202 0 2.018-.814 2.018-2.025zm-10.564 0c0-4.644 3.605-8.187 8.546-8.187 4.965 0 8.547 3.543 8.547 8.186s-3.582 8.186-8.547 8.186c-4.94 0-8.546-3.543-8.546-8.186zm-8.703 0c0-1.21-.816-2.025-2.017-2.025-1.202 0-2.018.814-2.018 2.024s.816 2.025 2.018 2.025c1.201 0 2.017-.814 2.017-2.025zm-10.563 0c0-4.644 3.604-8.187 8.546-8.187 4.965 0 8.546 3.543 8.546 8.186s-3.581 8.186-8.546 8.186c-4.942 0-8.546-3.543-8.546-8.186zm-9.905 2.948h-1.632v4.753h-7.004V21.144h7.004v4.71h1.632v-4.71h7.005v15.404h-7.005v-4.753zm70.289-21.597c1.156.815 3.038 1.387 4.489 1.365 1.065-.022 1.246-.264 1.246-.572 0-.309-.385-.44-1.677-.639-4.217-.637-6.03-2.376-6.03-4.752 0-2.685 2.539-5.546 8.342-5.546 2.698 0 6.12.88 7.707 2.025l-2.788 3.894c-1.541-.902-2.743-1.188-3.967-1.166-.861 0-1.065.308-1.065.594s.272.418 1.632.616c4.193.638 6.075 2.355 6.075 4.775 0 2.927-2.517 5.568-8.614 5.568-3.196 0-6.28-.836-8.252-2.267l2.902-3.895zm-13.78-5.104h-.409v3.168h.476c1.315 0 1.972-.66 1.972-1.585 0-.924-.612-1.583-2.04-1.583zm5.576 11.42l-5.985-4.115v3.52h-6.936V.517h8.432c5.1 0 7.005 2.707 7.005 5.04 0 1.386-.635 2.706-1.746 3.916l3.22 2.223-3.99 4.819zm-22.35-8.296c0-1.21-.816-2.024-2.018-2.024-1.2 0-2.017.813-2.017 2.024 0 1.21.816 2.025 2.017 2.025 1.202 0 2.018-.815 2.018-2.025zm-10.564 0c0-4.643 3.605-8.186 8.546-8.186 4.965 0 8.547 3.543 8.547 8.186s-3.582 8.186-8.547 8.186c-4.94 0-8.546-3.543-8.546-8.186zm-2.945 7.856l-9.158-4.511v4.357h-6.438V.406l.045-.022 9.158 4.6V.515h6.439v15.536l-.046.022zM29.836 8.218c0-1.21-.816-2.024-2.018-2.024-1.201 0-2.017.813-2.017 2.024 0 1.21.816 2.025 2.017 2.025 1.202 0 2.018-.815 2.018-2.025zm-10.564 0c0-4.643 3.605-8.186 8.546-8.186 4.965 0 8.547 3.543 8.547 8.186s-3.582 8.186-8.547 8.186c-4.941 0-8.546-3.543-8.546-8.186zM7.849 6.304h-.771v3.674h.862c1.541 0 2.29-.77 2.29-1.848 0-1.056-.726-1.826-2.381-1.826zM.731.516h6.982c5.849 0 9.272 3.059 9.272 7.372 0 4.709-3.514 8.032-9.68 8.032H.73V.516zm13.732 27.68c-1.292-.396-3.106-.814-4.33-.814-1.79 0-2.516.55-2.516 1.408 0 .858.726 1.408 2.516 1.408 1.202 0 2.88-.33 4.285-.77l2.788 5.523c-2.403 1.299-4.92 1.98-8.07 1.98C3.4 36.932 0 33.676 0 28.792c0-4.886 3.74-8.143 9.567-8.143 2.923 0 5.44.66 7.82 1.959l-2.924 5.589z" /></svg>`



function getLogo(fill) {
  return new Promise((resolve,reject) => {
    const LogoBlob = new Blob([Logo(fill)], {type: 'image/svg+xml'});
    const LogoURL = URL.createObjectURL(LogoBlob);

    const logo = new Image()
    logo.onload = () => {
      resolve(logo)
    }
    logo.src = LogoURL
  })
}
function getImage(src) {
  return new Promise((resolve,reject) => {
    const image = new Image()
    image.onload = () => {
      resolve(image)
    }
    image.src = src
  })
}